import template from './phoneRent.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, authenticationService, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.CurrentOrganization = null;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.CurrentOrganization = $rootScope.CurrentOrganization;

        ctrl.destroyWatch = eventService.onPhoneRent((_params) => {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                CurrentAccount: $rootScope.CurrentAccount,
                CurrentOrganization: ctrl.CurrentOrganization,
                IsEnterprise: $rootScope.IsEnterprise,
                isOwner: authenticationService.isOwner()
              },
              template,
              controllerAs: '$ctrl',
              controller(
                $state,
                organizationService,
                jsonFactory,
                CurrentAccount,
                CurrentOrganization,
                IsEnterprise,
                isOwner
              ) {
                const self = this;
                this.CurrentAccount = CurrentAccount;
                this.CurrentOrganization = CurrentOrganization;
                this.IsEnterprise = IsEnterprise;
                this.isOwner = isOwner;
                this.countries = [];

                this.countryIso = '';
                this.phoneType = '';
                this.regionName = '';
                this.numberPattern = '';
                this.isSearching = false;

                this.searchResults = null;
                this.limitResults = 10;
                this.currentPage = 0;
                this.totalPages = 0;

                this.selectedPhone = null;
                this.isReady = false;

                jsonFactory.getCountries().then((d) => {
                  self.countries = d;
                  self.isReady = true;
                });

                this.search = () => {
                  self.isSearching = true;
                  organizationService
                    .phoneSearch({
                      countryIso: self.countryIso,
                      phoneType: self.phoneType,
                      regionName: self.regionName,
                      numberPattern: self.numberPattern,
                      services: null,
                      limit: self.limitResults,
                      offset: 0
                    })
                    .then((results) => {
                      self.isSearching = false;
                      self.selectedPhone = null;
                      self.searchResults = results;
                      self.currentPage =
                        (self.searchResults.meta.Offset + self.searchResults.meta.Limit) /
                        self.searchResults.meta.Limit;
                      self.totalPages = Math.ceil(
                        self.searchResults.meta.TotalCount / self.searchResults.meta.Limit
                      );
                    });
                };
                this.previousPage = () => {
                  self.isSearching = true;
                  organizationService
                    .phoneSearch({
                      countryIso: self.countryIso,
                      phoneType: self.phoneType,
                      regionName: self.regionName,
                      numberPattern: self.numberPattern,
                      services: null,
                      limit: self.limitResults,
                      offset: self.searchResults.meta.Offset - self.limitResults
                    })
                    .then((results) => {
                      self.isSearching = false;
                      self.selectedPhone = null;
                      self.searchResults = results;
                      self.currentPage =
                        (self.searchResults.meta.Offset + self.searchResults.meta.Limit) /
                        self.searchResults.meta.Limit;
                    });
                };
                this.nextPage = () => {
                  self.isSearching = true;
                  organizationService
                    .phoneSearch({
                      countryIso: self.countryIso,
                      phoneType: self.phoneType,
                      regionName: self.regionName,
                      numberPattern: self.numberPattern,
                      services: null,
                      limit: self.limitResults,
                      offset: self.searchResults.meta.Offset + self.limitResults
                    })
                    .then((results) => {
                      self.isSearching = false;
                      self.selectedPhone = null;
                      self.searchResults = results;
                      self.currentPage =
                        (self.searchResults.meta.Offset + self.searchResults.meta.Limit) /
                        self.searchResults.meta.Limit;
                    });
                };
                this.selectPhone = ($event, phone) => {
                  if (self.selectedPhone) {
                    let len = self.searchResults.objects.length;
                    // eslint-disable-next-line no-plusplus
                    while (len--) {
                      self.searchResults.objects[len].isSelected = false;
                    }
                  }
                  if (self.selectedPhone && self.selectedPhone.number === phone.number) {
                    self.selectedPhone = null;
                  } else {
                    // eslint-disable-next-line no-param-reassign
                    phone.isSelected = true;
                    self.selectedPhone = phone;
                  }
                };
                this.chooseSubscription = () => {
                  $state.transitionTo('settings.plan-and-billing');
                  $mdDialog.cancel();
                };
                this.confirm = () => {
                  $mdDialog.hide(self.selectedPhone);
                };
                this.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((phone) => {
              ctrl.onFinished({ phone });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
